export default "__VITE_ASSET__Dq9ol3yi__"